import { RolUsuario } from "../_models/_enums/rolUsuario.enum";

const { Master, Admin, Ventas, Asociado, Compras, DemoAsociado, Proveedor, Cliente, DemoCliente } = RolUsuario;

export function puedeEntrarAdministracion(rol: RolUsuario): boolean {
    return [Master, Admin].includes(rol)
}

// Roles de empresas asociadas y cliente
export function puedeComprar(rol: RolUsuario): boolean {
    return [Asociado, Compras, DemoAsociado, Cliente, DemoCliente].includes(rol);
}

// Cualquiera excepto los roles de demo y Cliente
export function puedeVerCondiciones(rol: RolUsuario): boolean {
    return [Master, Admin, Ventas, Asociado, Proveedor].includes(rol);
}

// Cualquiera excepto Cliente y DemoCliente
export function puedeDescargarTarifas(rol: RolUsuario): boolean {
    return [Master, Admin, Ventas, Asociado, Compras, DemoAsociado, Proveedor].includes(rol);
}

// Solamente los roles de Unifersa
export function puedeDescargarCondiciones(rol: RolUsuario): boolean {
    return [Master, Admin].includes(rol);
}

// Cualquiera que pueda ver las condiciones
export function puedeDescargarAnexos(rol: RolUsuario): boolean {
    return [Master, Admin, Ventas, Asociado, Proveedor].includes(rol);
}

export function getNombreRol(rol: RolUsuario): string {
    switch (rol) {
        case Master:
            return 'Master';
        case Admin:
            return 'Administrador';
        case Ventas:
            return 'Ventas';
        case Asociado:
            return 'Asociado';
        case Compras:
            return 'Compras';
        case DemoAsociado:
            return 'Demo';
        case Cliente:
            return 'Cliente';
        case DemoCliente:
            return 'Demo'
        case Proveedor:
            return 'Proveedor';
    }
}

export function formatearTelefono(telefono: number): string {
    if (!telefono || !telefono.toString()) 
        return '';

    const telefonoFormateado = telefono.toString().replace(/\s+/g, '').match(/.{1,3}/g)?.join(' ') ?? telefono.toString();
    return telefonoFormateado;
}